/* eslint-disable no-shadow */
import PropTypes from 'prop-types';

import React from 'react';
import { FormattedMessage, FormattedTime } from 'react-intl';

const RefreshBalanceMessage = ({ card, className, ...otherProps }) => {
  const { lastBalanceCheckTime } = card;

  if (!lastBalanceCheckTime) {
    return null;
  }

  return (
    <span
      className={`color-textBlackSoft whiteSpace-noWrap ${className || ''}`}
      {...otherProps}
    >
      <FormattedMessage
        defaultMessage="as of {updateTime}"
        description="Indication of last time a user checked their card balance"
        id="accountCards.refreshBalanceMessage.updatedAsOfMessage"
        values={{
          updateTime: <FormattedTime value={lastBalanceCheckTime} />,
        }}
      />
    </span>
  );
};

RefreshBalanceMessage.propTypes = {
  lastBalanceCheckTime: PropTypes.any,
};

export default RefreshBalanceMessage;
